import { useContext } from 'react';
import { Button } from '@gtintel/platform-atoms';
import { SCOPING_ID } from '@gtintel/platform-constants';
import { ProjectContext } from '../../../ProjectApp/context';
const ScopingProjectButton = () => {
  const {
    edit
  } = useContext(ProjectContext);
  return <Button kind="primary" testId="scoping-project-button" onClick={() => edit({
    status: SCOPING_ID
  })}>
      Activate Project
    </Button>;
};
export default ScopingProjectButton;